import { render, staticRenderFns } from "./Component-3.vue?vue&type=template&id=31742008&scoped=true&"
import script from "./Component-3.vue?vue&type=script&lang=js&"
export * from "./Component-3.vue?vue&type=script&lang=js&"
import style0 from "./Component-3.vue?vue&type=style&index=0&id=31742008&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31742008",
  null
  
)

export default component.exports